<template>
<div class="vliveWeChatShare">
    <div class="dialog-form form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="left" size="mini">
            <el-form-item label="标题" prop="sharesubject">
                <el-input v-model.trim="ruleForm.sharesubject" maxlength="32" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="sharedesc">
                <el-input type="textarea" v-model.trim="ruleForm.sharedesc" maxlength="50" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item label="图标" prop="coverPicture" class="upload-image">
                <div class="upload cover-image" @click="openDialog">
                    <div class="avatar-uploader">
                        <div class="el-upload el-upload--text">
                            <i class="el-icon-plus avatar-uploader-icon icon_upload" v-if="!ruleForm.coverPicture.furl"></i>
                            <img :src="ruleForm.coverPicture.furl +'?'+timestamp" alt="" class="avatar" v-if="ruleForm.coverPicture.furl">
                        </div>
                    </div>
                </div>
                <div class="el-upload__tip">推荐512*512像素，尺寸必须大于300*300像素</div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
    <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></localCropper>
</div>
</template>

<script>
import LocalCropper from 'base/cropper/localCropper'
import {mapGetters, mapActions} from 'vuex'
import {editVliveWeChatShare} from 'api/api'
import {formatFileInfo} from 'common/js/tools'
import {vliveMsg} from 'api/message'
import $ from 'jquery'
export default {
    name: 'vliveWeChatShare',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            if (!value.furl) {
                callback(new Error('请选择图标'))
            } else {
                callback()
            }
        }
        return {
            timestamp: new Date().getTime(), // 时间戳
            ruleForm: {
                sharesubject: '',
                sharedesc: '',
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                }
            },
            cropperOption: {
                fixedNumber: [512, 512], // 截图框的宽高比例
                enlarge: 2.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 204.8, // 默认生成截图框宽度
                autoCropHeight: 204.8 // 默认生成截图框高度
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            rules: {
                sharesubject: [
                    {required: true, message: '请输入标题', trigger: 'blur'},
                    {min: 1, max: 32, message: '长度在3到32个字符', trigger: 'blur'}
                ],
                sharedesc: [
                    {required: true, message: '请输入描述', trigger: 'blur'},
                    {min: 1, max: 50, message: '长度在3到50个字符', trigger: 'blur'}
                ],
                coverPicture: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ]
            },
            imgRule: {
                cls: 'icon_default_image',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: 120,
                height: 120
            }
        }
    },
    mounted() {
    },
    methods: {
        _setImage(file) {
            this.timestamp = new Date().getTime()
            this.ruleForm.coverPicture = file
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let obj = $.extend(true, {}, Object.assign({}, this.ruleForm))
                    obj.coverPicture = formatFileInfo(obj.coverPicture)
                    this.$confirm(vliveMsg.submitWeChatShare.msg, vliveMsg.submitWeChatShare.title, {
                        confirmButtonText: vliveMsg.submitWeChatShare.confirmText,
                        cancelButtonText: vliveMsg.submitWeChatShare.cancelText
                    }).then(() => {
                        this._editVliveWeChatShare(obj)
                    })
                }
            })
            let tmp = Object.assign({}, this.ruleForm)
            this.setVliveModelWeChatShare(tmp)
        },
        _editVliveWeChatShare(obj) {
            this.setLoading(true)
            editVliveWeChatShare({
                data: Object.assign({}, obj, {assetinnerid: this.vliveModel.assetinnerid}),
                success: data => {
                    this.setLoading(false)
                    this.$message.success(vliveMsg.submitWeChatShare.successMsg)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        ...mapActions([
            'setVliveModelWeChatShare',
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                if (this.vliveModel.weChatShare.coverPicture && this.vliveModel.weChatShare.coverPicture.furl) {
                    this.ruleForm = Object.assign({}, this.vliveModel.weChatShare)
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel',
            'loading'
        ])
    },
    components: {
        LocalCropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.vliveWeChatShare {
    .upload-image{
        .icon, .avatar-uploader{
            box-sizing: border-box;
            height: 100px;
            width: 100px;
        }
    }
    .form{
        margin-top: 0;
    }
}
</style>
